import { Box } from '@mui/material';
import { useState } from 'react';
import { AvatarGlobal } from '../../UI/AvatarGlobal';
import { AvatarsModal } from '../../myAccount/AvatarsModal';
import { AvatarContainer, IconEditAvatar, ProfileIcons } from './StyledComponentHeader';

const handlePerfil = perfil => {
  return perfil === 'conservador'
    ? '/assets/images/perfiles/conservador.svg'
    : perfil === 'moderado'
      ? '/assets/images/perfiles/moderado.svg'
      : '/assets/images/perfiles/agresivo.svg';
};

const AvatarHeader = ({ userRisk, editable = false }) => {
  const [openModal, setOpenModal] = useState(false);
  const avatar = '../../../assets/images/log-out.svg';

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <AvatarContainer>
      <AvatarGlobal
        size={{
          desktop: { width: 80, height: 80 },
          tablet: { width: 66, height: 66 },
          mobile: { width: 46, height: 46 },
        }}
      />
      {/*  {!editable && <ProfileIcons src={handlePerfil(userRisk)} loading='lazy' alt='Icono Perfil' />}
      {editable && (
        <Box onClick={handleOpenModal} sx={{ cursor: 'pointer' }}>
          <IconEditAvatar />
        </Box>
      )}
      {openModal && (
        <AvatarsModal avatar={avatar} openModal={openModal} handleCloseModal={handleCloseModal} />
      )} */}
    </AvatarContainer>
  );
};

export default AvatarHeader;
